import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";

import {
    getFoodById,
    enableFood,
    disableFood,
    deleteFood,
} from "../services/adminApi";

import FoodHero from "../components/food/FoodHero";
import FoodTabs from "../components/food/FoodTabs";
import FoodActions from "../components/food/FoodActions";

import "../css/FoodDetails.css";

function FoodDetails() {

    const { id } = useParams();

    const navigate = useNavigate();

    const [food, setFood] = useState(null);

    const [loading, setLoading] = useState(true);

    const loadFood = async () => {

        try {

            setLoading(true);

            const res = await getFoodById(id);

            setFood(res.data.food);

        } catch (err) {

            console.error(err);

        } finally {

            setLoading(false);

        }

    };

    useEffect(() => {

        loadFood();

    }, [id]);

    const handleEnable = async (foodId) => {

        await enableFood(foodId);

        loadFood();

    };

    const handleDisable = async (foodId) => {

        await disableFood(foodId);

        loadFood();

    };

    const handleDelete = async (foodId) => {

        await deleteFood(foodId);

        navigate("/admin/foods");

    };

    if (loading) {

        return (

            <div className="food-details-loading">

                Loading Food...

            </div>

        );

    }

    if (!food) {

        return (

            <div className="food-details-loading">

                Food Not Found

            </div>

        );

    }

    return (

        <div className="food-details-page">

            <div className="food-details-header">

                <div>

                    <h1>Food Details</h1>

                    <p>
                        View complete information about this food item.
                    </p>

                </div>

                <button
                    className="back-btn"
                    onClick={() => navigate(-1)}
                >
                    Back
                </button>

            </div>

            <FoodHero food={food} />

            <FoodTabs food={food} />

            <FoodActions
                food={food}
                onEnable={handleEnable}
                onDisable={handleDisable}
                onDelete={handleDelete}
            />

        </div>

    );

}

export default FoodDetails;